<template>
  <div class="position_relative">
    <div class="padding_content" style="padding-bottom: 110px;" id="padding_dashboard">
      <!-- show if the user doesn't have any service -->
      <div v-if="!show" class="noService">
        <div>
          <img src="../../assets/img/Group.png" alt="" />
          <p>{{ $t('dashboard.noService') }}</p>
        </div>
      </div>
      <!-- end -->
      <div id="dashboard_content" v-if="show" class="wrapper_content">
        <!-- temp -->
        <DailyUsage :apiList="dailyAPICallList" />
        <userService
          :serviceList="user.services"
          :name="productName"
          :monthlyAPICalls="monthlyAPICalls"
          :billingCycle="billingCycle"
          @changeProductName="changeProductName"
          :apiList="dailyAPICallList"
        ></userService>
        <Detection
          :productName="productName"
          :apiList="dailyAPICallList"
          v-if="Object.keys(dailyAPICallList).length"
        ></Detection>
        <licensekey
          :licenseKey="user.licenseKey"
          :extraLicenseKeys="user.extraLicenseKeys"
        ></licensekey>
        <DeletedLicenseKeys :deletedKeys="deletedLicenseKeys" />
        <AddNewKey />
        <Invoice :invoiceList="allInvoices" />
      </div>
    </div>
    <Footer></Footer>
    <loading :show="loading"></loading>
  </div>
</template>

<script>
  import axios from 'axios'
  import userService from './user-service'
  import Detection from './detection'
  import licensekey from './license'
  import DeletedLicenseKeys from './DeletedLicenseKeys'
  import DailyUsage from './DailyUsage'
  import AddNewKey from './AddNewKey'
  import Invoice from './Invoice'
  import loading from '../../components/loading'
  import Footer from '../../components/footer'
  import { downAPP } from '../public/validator'
  import VueRouter from 'vue-router'

  const { isNavigationFailure, NavigationFailureType } = VueRouter

  export default {
    name: 'Home',
    components: { Detection, userService, DailyUsage, loading, licensekey, DeletedLicenseKeys, AddNewKey, Invoice, Footer },
    data() {
      return {
        user: [],
        product: {},
        dailyAPICallList: {},
        allInvoices: [],
        monthlyAPICalls: 0,
        billingCycle: { start: '', end: '' },
        productName: 'Mobile Malware Detection',
        show: false,
        loading: true,
        deletedLicenseKeys: []
      }
    },
    methods: {
      // debug
      log(item) {
        console.log(item)
      },
      changeProductName(data) {
        this.productName = data
      },
      getUserData: function() {
        let self = this
        axios
          .get('/api/user')
          .then(response => {
            this.loading = false
            self.$set(this, 'user', response.data)
            // Remove "No Subscription" item from services if the user has subscribed something
            if(this.user.services.length > 1) {
              for(let i=0; i<this.user.services.length; ++i) {
                if(this.user.services[i].name === 'No Subscription') this.user.services.splice(i, 1)
              }
            }
            // Set Product name to display
            if (this.user.services.length > 0) {
              this.productName = this.user.services[0].name
              this.show = true
            }
          })
          .catch(error => {
            console.log({ error })
            this.loading = false
            this.$router.push('/').catch(err => {
              // to hide the below error message
              if (!isNavigationFailure(err, NavigationFailureType.duplicated)) {
                throw Error(err)
              }
            })
          })
      },
      fetchAPICount: async function() {
        try {
          const response = await axios.get('/api/product/api-count/day')
          console.log('fetchAPICount', response.data.data)
          this.dailyAPICallList = response.data.data
        } catch (err) {
          console.log({ err })
        }
      },
      fetchMonthlyAPICount: async function() {
        try {
          const response = await axios.get('/api/product/api-count/billing-cycle')
          const { totalCounts, start, end } = response.data.data
          this.monthlyAPICalls = totalCounts
          this.billingCycle.start = start
          this.billingCycle.end = end
        } catch (err) {
          console.log({ err })
        }
      },
      fetchAllInvoices: async function() {
        try {
          const response = await axios.get('/api/payment/invoices')
          // console.log('fetchAllInvoices', {response});
          for (const invoice of response.data.data) {
            if (invoice.status === 'open') {
              // console.log('add open invoice', invoice)
              this.allInvoices.push(invoice)
            } else if (invoice.status === 'paid') {
              // console.log('add paid invoice', invoice)
              this.allInvoices.push(invoice)
            } else {
            }
          }
          // this.allInvoices = response.data.data
        } catch (err) {
          console.log({err});
        }
      }
    },
    mounted() {
      this.getUserData()
      this.fetchAPICount()
      this.fetchMonthlyAPICount()
      this.fetchAllInvoices()
      // update dailyAPICallList to rerender and display the latest info after the user specified the date range
      this.$root.$on('dailyAPICallList', async newData => {
        try {
          this.dailyAPICallList = newData
        } catch (err) {
          console.log({ err })
        }
      })
      // listen for deleted license keys updates
      this.$root.$on('deletedLicenseKeys', (keys) => {
        this.deletedLicenseKeys = keys || []
      })
      downAPP('padding_dashboard', '200px')
    },
    beforeDestroy() {
      this.$root.$off('dailyAPICallList')
      this.$root.$off('deletedLicenseKeys')
    }
  }
</script>

<style lang="scss" scoped>
  .noService {
    height: calc(100vh - 70px - 43px - 80px);
    @include flex-center;
    & > div {
      text-align: center;
      font-size: 24px;
      color: rgba(160, 160, 160, 1);
      line-height: 28px;
      & > img {
        width: 402px;
        height: 297px;
        margin-bottom: 12px;
      }
    }
  }
  @media screen and (max-width: 450px) {
    .noService {
      & > div {
        font-size: 14px;
        & > img {
          width: 200px;
          height: 150px;
        }
      }
    }
  }

  .wrapper_content {
    display: flex;
    flex-direction: column;
    gap: 32px;
  }
</style>



// WEBPACK FOOTER //
// src/views/Dashboard/dashboard.vue